<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="CONCEPTOS ASOCIADOS A UN USUARIO PARA CARGUE MASIVO" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup endpoint="usuarios"
                        :formItemConfig="fiOptions"
                        :label="$t('Usuarios')"
                        :decorator="['username', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                        ref="user"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
            <g-lookup endpoint="coc"
                        :label="$t('Concepto:')"
                        :formItemConfig="fiOptions"
                        :decorator="['con_codigo', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      ref="concepto"
            >
            </g-lookup>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    data () {
      return {
        pageTitle: 'Conceptos asociados a un usuario para cargue masivo',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'coc_nov',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Usuario', dataIndex: 'username', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'con_codigo'},
            {name: 'username'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.con_codigo)) {
              this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.con_codigo)
            }
            if (!this.$isEmpty(action.record.username)) {
              this.$refs.user && this.$refs.user.handleSearch(action.record.username)
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Novedades/CocNov.vue